"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GasMeterReadingForm = exports.createErrors = void 0;
var nebula_1 = require("@ovotech/nebula");
var ui_tools_1 = require("@ovotech/ui-tools");
var date_fns_1 = require("date-fns");
var react_1 = __importStar(require("react"));
var __generated__1 = require("../../../shared/api/kapi/v1/__generated__/");
var core_1 = require("../../../shared/core");
var components_1 = require("../../../shared/core/components");
var MeterReadingsContext_1 = require("../MeterReadingsContext");
var analytics_subjects_1 = require("../analytics-subjects");
var copy_1 = require("../copy");
var utils_1 = require("../pages/SubmitMeterReading/utils");
var utils_2 = require("../utils");
var LatestReadWithDate_1 = require("./LatestReadWithDate");
var MeterReadsDatepicker_1 = require("./MeterReadsDatepicker");
var gasIds = {
    gasMeterReadingId: 'meter-reading',
    dateId: 'gas-date',
};
var createErrors = function (currentSupply, date, meterReading, gasReading) {
    var _a;
    var message = (0, utils_1.validateInput)(meterReading ? Number(meterReading) : null, currentSupply.meterNumOfDigits);
    //TODO: getLatestMeterExchangeReading needs updating so that it also works with the kapi way of indentifying a MEX event - CPCE-2087
    var lastMexDate = (_a = (0, utils_2.getLatestMeterExchangeReading)(gasReading)) === null || _a === void 0 ? void 0 : _a.readingDateTime;
    var dateMessage = (0, utils_1.validateDate)((0, utils_1.getReadingDateTime)(date) || (0, date_fns_1.format)(new Date(), 'yyyy-MM-dd'), currentSupply.start, lastMexDate);
    var errors = [];
    if (message) {
        errors.push({
            id: gasIds.gasMeterReadingId,
            message: message.message,
            errorName: message.errorName,
        });
    }
    if (dateMessage) {
        errors.push({
            id: gasIds.dateId,
            message: dateMessage.message,
            errorName: dateMessage.errorName,
        });
    }
    return errors;
};
exports.createErrors = createErrors;
var GasMeterReadingForm = function (_a) {
    var _b;
    var currentSupply = _a.currentSupply, latestReading = _a.latestReading, isLoading = _a.isLoading, onSubmit = _a.onSubmit, onError = _a.onError;
    var _c = (0, core_1.useCopy)(copy_1.defaultOptions), copy = _c.copy, Copy = _c.Copy;
    var _d = __read((0, react_1.useState)(''), 2), meterReading = _d[0], setMeterReading = _d[1];
    var _e = __read((0, react_1.useState)('Today'), 2), date = _e[0], setDate = _e[1];
    var _f = __read((0, react_1.useState)([]), 2), errors = _f[0], setErrors = _f[1];
    var _g = (0, core_1.useComponents)(), NumberField = _g.NumberField, PrimaryCTAButton = _g.PrimaryCTAButton, Stack = _g.Stack;
    var dispatch = (0, ui_tools_1.useAnalytics)().dispatch;
    var readings = (0, react_1.useContext)(MeterReadingsContext_1.MeterReadingsContext).readings;
    var onMeterReadingChange = function (_a) {
        var meterReading = _a.currentTarget.value;
        setMeterReading(meterReading);
    };
    var getCopyForErrors = function (error) { return (__assign(__assign({}, error), { message: copy(error.message, {
            numOfDigits: currentSupply.meterNumOfDigits,
        }) })); };
    var handleSubmit = function (event) {
        var _a;
        event.preventDefault();
        setErrors([]);
        onError([]);
        var errors = (0, exports.createErrors)(currentSupply, date, meterReading, readings['gas']).map(getCopyForErrors);
        if (errors.length) {
            setErrors(errors);
            onError(errors);
            dispatch({
                name: analytics_subjects_1.METER_READ_SUBMIT_ERROR,
                type: 'render',
                properties: (_a = {
                        errors: errors
                    },
                    _a[core_1.INTERNAL_EVENT_FLAG] = true,
                    _a),
            });
        }
        else {
            onSubmit({
                sprn: currentSupply.mpxn,
                value: meterReading,
                dateTime: (0, utils_1.getReadingDateTime)(date),
                meterSerialNumber: currentSupply.msn || '',
                force: __generated__1.MeterReadForceType.NoForce,
            });
        }
    };
    var context = latestReading ? (react_1.default.createElement(LatestReadWithDate_1.LatestReadWithDate, { reading: latestReading, meterNumOfDigits: currentSupply.meterNumOfDigits })) : null;
    return (react_1.default.createElement("form", { onSubmit: handleSubmit, method: "POST", noValidate: true },
        react_1.default.createElement(Stack, { spaceBetween: [4, 6] },
            react_1.default.createElement(components_1.RegisterSummary, { context: context }),
            react_1.default.createElement(components_1.IconSummarySpacer, null,
                react_1.default.createElement(NumberField, { "data-testid": gasIds.gasMeterReadingId, id: gasIds.gasMeterReadingId, label: copy('submitMeterReading.inputLabel'), value: meterReading, onChange: onMeterReadingChange, hint: copy('submitMeterReading.inputHintText'), error: (0, nebula_1.getErrorMessage)(gasIds.gasMeterReadingId, errors), characters: 6, disabled: isLoading })),
            !currentSupply.isInOMRWindow && (react_1.default.createElement(components_1.IconSummarySpacer, null,
                react_1.default.createElement(MeterReadsDatepicker_1.MeterReadsDatepicker, { id: gasIds.dateId, supplyStartDate: currentSupply.start, setDate: setDate, fuel: "gas", error: (0, nebula_1.getErrorMessage)(gasIds.dateId, errors) }))),
            react_1.default.createElement(components_1.IconSummarySpacer, null,
                react_1.default.createElement(ui_tools_1.AnalyticsClick, { name: analytics_subjects_1.SUBMIT_METER_READING, properties: (_b = {
                            meterData: (0, utils_1.getMeterReadAnalyticsData)(currentSupply, 'gas'),
                            backdatedDays: (0, utils_1.getBackdatedDaysToToday)(date),
                            datepickerEntry: date
                        },
                        _b[core_1.INTERNAL_EVENT_FLAG] = true,
                        _b) },
                    react_1.default.createElement(PrimaryCTAButton, { type: "submit", disabled: isLoading, "data-testid": "submit-meter-reading" },
                        react_1.default.createElement(Copy, { copyKey: "submitMeterReadingSubmitLabel", values: { fuel: 'gas' } })))))));
};
exports.GasMeterReadingForm = GasMeterReadingForm;
